var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFullscreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.9999 4.75V2.5H11.7499V0.861008H13.9326C14.4049 0.861008 14.8073 1.02731 15.1399 1.35993C15.4725 1.69253 15.6388 2.09497 15.6388 2.56726V4.75H13.9999ZM0.360859 4.75V2.56726C0.360859 2.09497 0.527165 1.69253 0.859777 1.35993C1.19238 1.02731 1.59482 0.861008 2.06711 0.861008H4.24985V2.5H1.99985V4.75H0.360859ZM11.7499 13.139V11.5H13.9999V9.25H15.6388V11.4327C15.6388 11.905 15.4725 12.3075 15.1399 12.6401C14.8073 12.9727 14.4049 13.139 13.9326 13.139H11.7499ZM2.06711 13.139C1.59482 13.139 1.19238 12.9727 0.859777 12.6401C0.527152 12.3075 0.36084 11.905 0.36084 11.4327V9.25H1.99985V11.5H4.24985V13.139H2.06711ZM3.49985 10V4H12.4999V10H3.49985ZM5.13885 8.36101H10.8609V5.639H5.13885V8.36101Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreen);
export default __webpack_public_path__ + "static/media/fullscreen.615a4294.svg";
export { ForwardRef as ReactComponent };